/**
 * redirectTo sends the browser to the acquirer's HOSTED payment form.
 *
 * # Why this is a module of its own for one line
 *
 * It is the one place this SPA leaves itself, and it is the step where the subscriber
 * stops looking at our page and starts typing a card number on somebody else's. Two
 * things follow:
 *
 *  1. **it must be observable in a test.** «The browser was sent to the URL the server
 *     returned» is the whole assertion of the card flow — a screen that started an order
 *     and then rendered a confirmation without navigating would look correct in every
 *     other arm, and the subscriber would sit on a page waiting for a form that never
 *     opens. A module boundary is what lets `PaymentScreen.test.tsx` see the call;
 *  2. **jsdom implements no navigation.** Calling `window.location.assign` in a test
 *     prints a «Not implemented» through the virtual console, and a suite whose output is
 *     full of expected noise is a suite in which nobody reads the unexpected line — the
 *     same argument this project makes for never piping a gate through `tail`.
 *
 * `assign` and not `href =`: they are equivalent in every browser, and `assign` reads as
 * the deliberate act it is.
 *
 * ⚠ THE URL IS THE SERVER'S, WHOLE. It is a signed parameter set with its own validity
 * window — nothing here appends to it, rewrites its host, or stores it, and nothing logs
 * it, because it carries the order identifier the signature covers.
 */
export function redirectTo(url: string): void {
  window.location.assign(url);
}
